export function isPageZoomWheel(event) {
  return Boolean(event?.ctrlKey);
}

export function blockPageZoomWheel(event) {
  if (!isPageZoomWheel(event) || !event.cancelable) {
    return;
  }

  event.preventDefault();
}

export function blockPageZoomGesture(event) {
  if (!event?.cancelable) {
    return;
  }

  event.preventDefault();
}

const ZOOM_KEY_CODES = new Set([
  "Equal",
  "Minus",
  "NumpadAdd",
  "NumpadSubtract",
]);

/** Cmd/Ctrl plus or minus. Reset (Cmd/Ctrl 0) stays available. */
export function isPageZoomKey(event) {
  if (!event || event.altKey) {
    return false;
  }

  if (!event.ctrlKey && !event.metaKey) {
    return false;
  }

  return ZOOM_KEY_CODES.has(event.code);
}

export function blockPageZoomKey(event) {
  if (!isPageZoomKey(event) || !event.cancelable) {
    return;
  }

  event.preventDefault();
}
